import React from 'react';
import { CoursesTest } from '../CoursesTest/CoursesTest';
import { ICourseData } from '../shared/CourseItem/CourseItem';

export interface ICoursesProps {
	courses: ICourseData[];
}

export const Courses = (props: ICoursesProps) => <CoursesTest {...props} />;
